<template>
  <v-flex
    id="metrics"
    class="question"
  >
    <h2 class="display-3 display-3_dark required">
      {{ getFamilyGuideQuestions.label }}
    </h2>
    <div v-if="getFamilyGuideQuestions.text">
      <p
        v-for="(text, index) in getFamilyGuideQuestions.text"
        :key="index"
        class="mb-0 f-1"
      >
        {{ text }}
      </p>
    </div>
    <v-layout
      v-if="!allowModifyFamilyGuide"
      align-center
      mb-3
    >
      <v-icon
        color="sz_red"
        size="32"
      >
        error_outline
      </v-icon>
      <p class="f-1 mb-0 ml-2 fw-600 sz_grafit--text">
        {{ $t('sheet.sheetOne.meeting.family_guide.disabled_information') }}
      </p>
    </v-layout>
    <div class="content">
      <h4 class="display-1 display-1_dark mb-4">
        {{ getFamilyGuideQuestions.representatives.label }}
      </h4>
      <FamilyRepresentativeForm
        v-model="representatives"
        :read-only="disableForm"
      />
    </div>
  </v-flex>
</template>

<script>
import FamilyRepresentativeForm from '@/components/widgets/sheet/FamilyRepresentativeForm';
import filters from '@/constants/filters';
import { mapGetters } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getFamilyGuideField',
    mutationType: 'sheet/updateFamilyGuideField'
});

export default {
    name: 'FamilyGuide',
    components: {
        FamilyRepresentativeForm
    },
    filters: {
        ...filters
    },
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapFields(['representatives']),
        ...mapGetters('sheet', ['getFamilyGuideQuestions']),
        allowModifyFamilyGuide () {
            return this.$store.getters['sheet/getAllowModifyFamilyGuide'];
        },
        disableForm () {
            return this.readOnly || !this.allowModifyFamilyGuide;
        }
    }
};
</script>

<style scoped></style>
